module.exports = __webpack_public_path__ + "img/product.a2b43acf.jpg";